<app-si-dialog modalBodyClasses="flex flex-col h-full w-full" [hideHeader]="true" [isLoading]="contactsService.createContactLoadedFlag | async">
	<ng-template appDialogBody>
		<div class="flex flex-col h-full w-full overflow-hidden" style="min-height: 250px">
			<div>
				<app-modal-header-wizard [pages]="headers" [listType]="'Companies'"></app-modal-header-wizard>
			</div>
			<div class="flex flex-col h-full w-full pt-6 overflow-auto" [ngClass]="{'disable': contactsService.createContactLoadedFlag | async}">
				<div class="container mx-auto px-4" [hidden]="currentPage !== pages.uploadListPage">
					<div class="flex flex-wrap -mx-2 text-center mb-4">
						<div class="w-full sm:flex-none sm:w-full px-2">
							<h5>Upload your Account List</h5>
							<strong>
								The file must contain <u>either a domain or a name </u> for each company.<br />
								You can upload a maximum of <u>10,000 accounts</u> per list.
							</strong>
						</div>
					</div>
					<div class="flex flex-col gap-7">
						<div class="flex flex-wrap -mx-2">
							<label class="w-full sm:flex-none sm:w-1/4 text-right ml-auto self-center px-2">
								<b>List Name:</b>
							</label>
							<div class="w-full sm:flex-none sm:w-3/4 px-2">
								<mat-form-field appearance="outline" class="w-full">
									<mat-label>List Name</mat-label>
									<input matInput type="text" [(ngModel)]="list.name" maxlength="100" placeholder="Enter a name for your list" />
								</mat-form-field>
							</div>
						</div>
						<div class="flex flex-wrap -mx-2">
							<label class="w-full sm:flex-none sm:w-1/4 text-right ml-auto mb-1 self-center px-2">
								<b>CSV File:</b>
							</label>
							<div class="w-full sm:flex-none sm:w-3/4 px-2">
								<span [hidden]="list.file" class="py-1">
									<label for="file-upload" class="custom-file-upload">
										Choose File
									</label>
									<input id="file-upload" type="file" name="listFile"
										(change)="onFileSelected($event)" #listFile accept=".csv,.txt" />
									(need an example?
									<a id="btnDownload" download="companytemplate.csv"
										href="../../../../../assets/csv/companytemplate.csv" target="_blank">Download the template</a>).
								</span>

								<span [hidden]="list.file === undefined">
									<span>{{list.fileName}}</span>&nbsp;&nbsp;&nbsp;<button matButton="outlined" class="mat-small-button" type="reset"
										(click)="resetFile()">clear</button>
								</span>
							</div>
						</div>
						<div class="flex flex-wrap -mx-2">
							<label class="w-full sm:flex-none sm:w-1/4 text-right ml-auto self-center px-2">
								<b>Availability:</b>
							</label>
							<div class="w-full sm:flex-none sm:w-3/4 px-2">
								<mat-form-field appearance="outline" class="w-full">
									<mat-label>Availability</mat-label>
									<mat-select [(ngModel)]="list.isPublic" placeholder="Select availability" #siSelectRef="matSelect">
										<mat-option [value]="false">Private</mat-option>
										<mat-option [value]="true">Team</mat-option>
									</mat-select>
									<fa-icon matSuffix aria-hidden="true" class="si-icon si-select-arrow" [class.si-select-arrow--open]="siSelectRef.panelOpen" [icon]="['fal', 'chevron-down']"></fa-icon>
								</mat-form-field>
							</div>
						</div>
						<div class="flex flex-wrap -mx-2">
							<label class="w-full sm:flex-none sm:w-1/4 text-right ml-auto self-center px-2">
								<b>Tags (Optional):</b>
							</label>
							<div class="w-full sm:flex-none sm:w-3/4 px-2">
								<app-multi-selector-form-field
									showChipsList="true"
									[items]="tagList$ | async"
									bindLabel="name"
									bindValue="id"
									label="Tags"
									placeholder="Tags"
									[(ngModel)]="list.tags"
									name="tags"
									[isLoading]="(isCreateTagLoading$ | async) || (isGetTagLoading$| async)"
									ngDefaultControl
									listElementTooltipIfTruncated="true"
								>
									<ng-template #preOption let-value="inputValue">
										<span><a class="cp-dark-link" (click)="createTag(value)">{{value}} (Create New)</a></span>
									</ng-template>
								</app-multi-selector-form-field>
							</div>
						</div>
						<div class="flex flex-wrap -mx-2">
							<label class="w-full sm:flex-none sm:w-1/4 text-right ml-auto self-center px-2">
								<b>Skip First Row:</b>
							</label>
							<div class="w-full sm:flex-none sm:w-3/4 flex items-center px-2">
								<mat-checkbox  [(ngModel)]="list.skipFirstLine">
									<i class="text-[0.875em]">Check if the first line is a header</i>
								</mat-checkbox>
							</div>
						</div>
					</div>
				</div>

				<div class="container mx-auto px-4" [hidden]="currentPage !== pages.columnMappingPage">
					<div class="text-center">
						<h5 class="text-center">Map Fields</h5>
						<p class="small-text text-center text-[0.875em]">Select the matching column in the CSV for each of the
							fields. If a field does not exist in your CSV file, then select -- skip --.</p>
					</div>
					<div class="text-danger text-center" *ngIf="isError != undefined">
						<p>{{isError}}</p>
					</div>

					<div class="flex flex-wrap -mx-2 gap-y-7">
						<div class="flex-none w-1/2 px-2" *ngFor="let field of columnStepDetails">
							<mat-form-field [ngClass]="{ 'mat-form-field-invalid': field.isError }" appearance="outline" class="w-full">
								<mat-label>{{field.displayName}}</mat-label>
								<mat-select [id]="field.propertyName" [name]="field.propertyName" [(ngModel)]="selectedColumnValues[field.propertyName]" #siSelectRef2="matSelect">
									<mat-option [value]="'0'">-- skip --</mat-option>
									<mat-option *ngFor="let item of fileHeaders; let i = index" [value]="(i+1)">{{item}}</mat-option>
								</mat-select>
								<fa-icon matSuffix aria-hidden="true" class="si-icon si-select-arrow" [class.si-select-arrow--open]="siSelectRef2.panelOpen" [icon]="['fal', 'chevron-down']"></fa-icon>
							</mat-form-field>
						</div>
					</div>
				</div>

				<div class="container mx-auto px-4" [hidden]="currentPage !== pages.resultPage">
					<div class="panel panel-default" *ngIf="!(contactsService.createContactLoadedFlag | async)">
						<div class="panel-heading text-left hidden">
							<h5 class="mt-2">Company Coverage</h5>
						</div>
						<div class="company-list-header text-center">
						</div>
						<div class="container mx-auto px-4">
							<div class="flex flex-wrap -mx-2">
								<div class="w-full sm:flex-none sm:w-1/6 px-2">
									<div class="text-secondary company-list-table mb-6">
										<div class="flex flex-wrap -mx-2">
											<div class="w-full text-center sm:flex-none sm:w-full py-2 px-2"><b>List Size</b></div>
										</div>
										<div class="shadow-bs international-height">
											<div class="text-center py-2"><b>{{ totalCount | number : 0 }}</b><br />
											</div>
										</div>
									</div>
								</div>
								<div class="w-full sm:flex-none sm:w-5/6 px-2">
									<div class="text-secondary company-list-table mb-6">
										<div class="flex flex-wrap -mx-2">
											<div class="text-center w-1/4 py-2"><b>Matched</b></div>
											<div class="text-center w-1/4 py-2"><b>UnMatched</b></div>
											<div class="text-center w-1/4 py-2"><b>Duplicates</b></div>
											<div class="text-center w-1/4 py-2"><b>Invalid</b></div>
										</div>
										<div class="flex flex-wrap -mx-2 shadow-bs">

											<div class="text-center w-1/4 py-2">
												<b>{{buyingCenterDetails.matched | number : 0}}</b>
												<span>
													({{ (buyingCenterDetails.matched == 0) ? '0%' : (buyingCenterDetails.matched /
													totalCount) | percent : '1.0-2' }})
												</span><br />
												&nbsp;
											</div>
											<div class="text-center w-1/4 py-2">
												<div>
													<b>{{buyingCenterDetails.unmatched | number : 0}}</b>
													<span>
													({{ (buyingCenterDetails.unmatched == 0) ? '0%' : (buyingCenterDetails.unmatched
															/ totalCount) | percent : '1.0-2' }})
													</span>
												</div>
												<div class="flex justify-center items-center">
                          <div [matTooltip]="'Research on Demand'">
                            <button
                              *ngIf="commonUtilService.hasRODCredit"
                              matIconButton
                              type="button"
                              class="mat-primary"
                              [disabled]="!buyingCenterDetails.unmatched > 0"
                              (click)="onRoDModal('unmatched')"
                            >
                              <fa-icon class="si-icon" [icon]="['fal', 'magnifying-glass-plus']"></fa-icon>
                            </button>
                          </div>
                          <div [matTooltip]="'Export'">
                            <button
                              type="button"
                              matIconButton
                              class="mat-primary"
                              [matMenuTriggerFor]="fstMenu"
                              [disabled]="buyingCenterDetails.unmatched == 0 || !(accountAttributesEnum.CSVEXPORT | hasAccess)"
                            >
                              <fa-icon class="mb-1 si-icon" [icon]="['fal', 'share-from-square']"></fa-icon>
                            </button>
                            <mat-menu #fstMenu>
                              <button *ngIf="accountAttributesEnum.CSVEXPORT | hasAccess" mat-menu-item (click)="onExport('unmatched', 'csv')">
                                <span class="export-icon csv"></span>Export Original Records
                              </button>
                            </mat-menu>
                          </div>
												</div>
											</div>
											<div class="text-center w-1/4 py-2">
												<div>
													<b>{{ buyingCenterDetails.duplicates | number : 0 }}</b>
												</div>
												<div class="flex justify-center">
                          <div [matTooltip]="'Export'">
                            <button
                              matIconButton
                              class="mat-primary"
                              type="button"
                              [matMenuTriggerFor]="scdMenu"
                              [disabled]="buyingCenterDetails.duplicates == 0 || !(accountAttributesEnum.CSVEXPORT | hasAccess)"
                            >
                              <fa-icon class="mb-1 si-icon" [icon]="['fal', 'share-from-square']"></fa-icon>
                            </button>
                            <mat-menu #scdMenu>
                              <button mat-menu-item *ngIf="accountAttributesEnum.CSVEXPORT | hasAccess" (click)="onExport('duplicate', 'csv')">
                                <span class="export-icon csv"></span>Export Original Records
                              </button>
                            </mat-menu>
                          </div>
												</div>
											</div>
											<div class="text-center w-1/4 py-2">
												<div>
													<b>{{ buyingCenterDetails.invalid | number : 0 }}</b>
													({{(buyingCenterDetails.invalid / totalCount) | percent : '1.0-2' }})<br />
												</div>
												<div class="flex justify-center">
                          <div [matTooltip]="'Export'">
                            <button
                              matIconButton
                              class="mat-primary"
                              type="button"
                              [matMenuTriggerFor]="thrdMenu"
                              [disabled]="buyingCenterDetails.invalid == 0 || !(accountAttributesEnum.CSVEXPORT | hasAccess)"
                            >
                              <fa-icon class="mb-1 si-icon" [icon]="['fal', 'share-from-square']"></fa-icon>
                            </button>
                            <mat-menu #thrdMenu>
                              <button mat-menu-item *ngIf="accountAttributesEnum.CSVEXPORT | hasAccess" (click)="onExport('invalid', 'csv')">
                                <span class="export-icon csv"></span>Export Original Records
                              </button>
                            </mat-menu>
                          </div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="flex flex-wrap -mx-2">
								<div class="w-full sm:flex-none sm:w-1/4 px-2">
									<div class="text-secondary company-list-table mb-6">
										<div class="flex flex-wrap -mx-2">
											<div class="w-full text-center sm:flex-none sm:w-full py-2 px-2"><b>USA: Human Verified</b></div>
										</div>
										<div class="shadow-bs international-height">
											<div class="text-center py-2">
												<b class="a" (click)="onViewCompanies('usaHumanVerified')">{{buyingCenterDetails.usaHumanVerifiedCount | number : 0 }}</b>
											</div>
										</div>
									</div>
								</div>

								<div class="w-full sm:flex-none sm:w-1/4 px-2">
									<div class="text-secondary company-list-table mb-6">
										<div class="flex flex-wrap -mx-2">
											<div class="w-full text-center sm:flex-none sm:w-full py-2 px-2"><b>USA: All Companies
												</b></div>
										</div>
										<div class="shadow-bs international-height">
											<div class="text-center py-2">
												<b class="a" (click)="onViewCompanies('usaMachineVerified')">{{buyingCenterDetails.usaMachineVerifiedCount | number : 0 }}</b>
											</div>
										</div>
									</div>
								</div>

								<div class="w-full sm:flex-none sm:w-1/4 px-2">
									<div class="text-secondary company-list-table mb-6">
										<div class="flex flex-wrap -mx-2">
											<div class="w-full text-center sm:flex-none sm:w-full py-2 px-2"><b>Intl: Human Verified</b></div>
										</div>
										<div class="shadow-bs international-height">
											<div class="text-center py-2">
												<b class="a" (click)="onViewCompanies('intlHumanVerified')">{{ buyingCenterDetails.intlHumanVerifiedCount | number : 0 }}</b>
											</div>
										</div>
									</div>
								</div>

								<div class="w-full sm:flex-none sm:w-1/4 px-2">
									<div class="text-secondary company-list-table mb-6">
										<div class="flex flex-wrap -mx-2">
											<div class="w-full text-center sm:flex-none sm:w-full py-2 px-2"><b>Intl: All Companies</b></div>
										</div>
										<div class="shadow-bs international-height">
											<div class="text-center py-2">
												<b class="a" (click)="onViewCompanies('intlMachineVerified')">{{buyingCenterDetails.intlMachineVerifiedCount | number : 0 }}</b>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="panel-heading text-left hidden">
							<h5 class="mt-2">Contact Coverage</h5>
						</div>
						<mat-tab-group>
							<mat-tab>
								<ng-template matTabLabel>
									<span>Human + Email Verified
									<br />{{verifiedContacts[0].TotalContacts | number}}</span>
								</ng-template>
								<app-contact-matrix [data]="verifiedContacts[0]" tabName="verified" (contactClick)="onContactClick()"></app-contact-matrix>
							</mat-tab>
							<mat-tab>
								<ng-template matTabLabel>
									<span>All Contacts
									<br />{{verifiedContacts[1].TotalContacts | number}}</span>
								</ng-template>
								<app-contact-matrix [data]="verifiedContacts[1]" tabName="all" (contactClick)="onContactClick()"></app-contact-matrix>
							</mat-tab>
						</mat-tab-group>
					</div>
				</div>
			</div>
		</div>
		<div *ngIf="(contactsService.createContactLoadedFlag | async)" class="result-loader">
			<mat-spinner></mat-spinner>
		</div>
	</ng-template>

	<ng-template appDialogFooter>
		<div class="flex flex-wrap -mx-2 gap-0 w-full">
			<div class="grow shrink-0 basis-0 px-2">
				<button matButton="outlined" type="button"
						[disabled]="(contactsService.createContactLoadedFlag | async)" (click)="close()"
						*ngIf="currentPage < 2 ">Cancel</button>
			</div>
			<div class="flex-none w-auto px-2">
				<button matButton="filled" type="button" class="float-right" (click)="onNext()"
						[disabled]="isNextButtonDisabled() || (contactsService.createContactLoadedFlag | async)">
					{{nextButtonCaption}}</button>
				<button matButton="outlined" type="button" class="float-right mr-2" (click)="onPrevious()"
						*ngIf="currentPage === 1" [hidden]="isListProcessing">Previous</button>
			</div>
		</div>
	</ng-template>
</app-si-dialog>

